import React, { useCallback } from "react";
import clsx from "clsx";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { reduxForm, getFormValues, Field, change } from "redux-form";

import { Skeleton, SelectAsyncForMccCodeSection, Button } from "components";
import { DebounceTimeout } from "globalConstants";
import { useMccCodes } from "queries";
import { required } from "validators/validation";

import { ReactComponent as CancelIcon } from "static/images/cancel.svg";
import { ReactComponent as CheckDone } from "static/images/checked.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "../../merchantInfo.module.scss";

let MerchantDescriptionForm = ({
	isLoading,
	handleSubmit,
	formValues,
	editField,
	editing,
	dispatch,
	isEditable,
}) => {
	const FieldWithLoader = useCallback(
		({ children }) => {
			if (isLoading) {
				return (
					<Skeleton
						variant="text"
						marginRight="15px"
						height="24px"
						width="90%"
					/>
				);
			} else {
				return <span className={styles.content}>{children}</span>;
			}
		},
		[isLoading],
	);

	const { loadMccCodes } = useMccCodes();

	const handleMccCodeChange = options => {
		dispatch(change("merchantForm", "merchantDescription", options.label));
		dispatch(change("merchantForm", "mccCode", options.value));
		dispatch(change("merchantForm", "mccAliasId", options.id));
	};

	return (
		<div className={styles.merchantFormDescForm}>
			<Form onSubmit={handleSubmit}>
				<div className={styles.merchantFormDesc}>
					<p className={styles.merchantLabel}>
						What type of business is this?
					</p>
					<div className={styles.formContent}>
						<FieldWithLoader>
							MCC - {formValues.mccCode || ""}
							<div className="float-right">
								{isEditable ? (
									editing ? (
										<div className="text-nowrap">
											<Button
												onClick={editField}
												icon={<CancelIcon />}
												btnIcon
												variant="secondary-danger"
												size="sm"
											/>
											<Button
												type="submit"
												icon={<CheckDone />}
												btnIcon
												variant="secondary"
												size="sm"
											/>
										</div>
									) : (
										<Button
											onClick={editField}
											icon={<EditIcon />}
											btnIcon
											variant="secondary"
											size="sm"
										/>
									)
								) : null}
							</div>
						</FieldWithLoader>
					</div>
				</div>
				<div
					className={clsx(styles.merchantFormDesc, styles.mccSection)}
				>
					<p className={styles.merchantLabel}></p>
					<div className={styles.formMerchantDesc}>
						{editing ? (
							<div className="mb-3">
								<Field
									component={SelectAsyncForMccCodeSection}
									cacheOptions
									defaultOptions
									debounceTimeout={DebounceTimeout}
									loadOptions={loadMccCodes}
									onChangeAlias={handleMccCodeChange} // Used like this bc Field also has it's own onChange
									placeholder="Enter MCC code description"
									name="merchantDescription" // That's actually not used bc it's being reset in the onChange
									value={{
										value: formValues.mccCode,
										label: formValues.merchantDescription,
									}}
									additional={{ page: 0 }}
									validate={required}
									tabIndex="10"
									isOptionSelected={o => {
										return (
											o.value === formValues.mccCode &&
											o.label ===
												formValues.merchantDescription
										);
									}}
								/>
							</div>
						) : (
							<p className={styles.content}>
								{formValues?.merchantDescription}
							</p>
						)}
					</div>
				</div>
			</Form>
		</div>
	);
};

MerchantDescriptionForm = reduxForm({
	form: "merchantForm",
	destroyOnUnmount: false,
	enableReinitialize: true,
})(MerchantDescriptionForm);

MerchantDescriptionForm = connect(state => ({
	loading: state.merchantInfo.loading,
	initialValues: state.merchantInfo.merchantInfo,
	formValues: getFormValues("merchantForm")(state) || {},
}))(MerchantDescriptionForm);

export default MerchantDescriptionForm;
